// extracted by mini-css-extract-plugin
export default {"Datalist":"datalist_Datalist__7Sgs5","fullWidth":"datalist_fullWidth__R8gjK"};